var React = require('react');

function MinusInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5 12h14"}));
}

MinusInline.defaultProps = {"viewBox":"0 0 24 24","className":"stroke"};

module.exports = MinusInline;

MinusInline.default = MinusInline;
